module.exports = __webpack_public_path__ + "img/icon_--_sync.8e6c3dfe.png";